/**
 * TRADE 定制：Hextom 货币/语言选择器 —— 吸附到导航栏下方，随导航一起置顶
 *
 * 早期版本是「每帧测量导航栏底边、再把位置写进 CSS 变量」的跟随式实现：
 * 测量发生在浏览器绘制之前，快速滚动时测量值和实际绘制值有 1 帧的时间差，
 * 于是浮层会一快一慢地“追”导航，看起来上下跳动。
 *
 * 这版改成「直接把选择器移进导航栏容器」：.ht-tms--float 变成
 * .header-wrapper（即 Dawn 的 sticky-header，注意它本身是 position:relative）
 * 的子元素，并用相对定位贴在导航正下方（top: calc(100% + 10px)）。
 * 由于和导航同处一个元素、同在一个滚动上下文里，浏览器让它们天然完全同步，
 * 完全不需要逐帧测量 —— 不会再有跳动的可能；导航被顶置/收缩时它也一起变化，
 * 正好是“跟导航栏固定逻辑一样”。
 *
 * Hextom 是异步把 .ht-tms--float 挂到 <body> 尾部的，且可能在个别时机重建或
 * 挪动它，所以这里：
 *   - 轮询等待它出现（最多 20s）；
 *   - 用 MutationObserver 监控，一旦被挪出导航栏就再钉回去；
 *   - 轮询超时仍找不到导航栏时，给 <html> 加 tms-float-reveal，CSS 兜底放行显示。
 */
(() => {
  const FLOAT_SELECTOR = '.ht-tms--float';
  const HOST_SELECTOR = '.header-wrapper'; // Dawn 的 sticky-header
  const REVEAL_CLASS = 'tms-float-reveal';
  const MAX_ATTEMPTS = 200; // 100ms × 200 = 20s

  const docEl = document.documentElement;

  const getHost = () => document.querySelector(HOST_SELECTOR);
  const getFloat = () => document.querySelector(FLOAT_SELECTOR);

  /**
   * 把浮层移到导航栏容器里（不在里面时才移动）。
   * @returns {boolean} 成功安置到导航栏下返回 true
   */
  function home() {
    const host = getHost();
    const float = getFloat();
    if (!host || !float) return false;

    if (float.parentElement !== host) {
      host.appendChild(float); // 挂到导航元素末尾，作为绝对定位子元素
    }
    return true;
  }

  // —— 轮询：等 Hextom 把浮层注入，同时等导航栏出现 ——
  let attempts = 0;
  const timer = setInterval(() => {
    if (home()) {
      clearInterval(timer);
      startWatchers();
    } else if (++attempts >= MAX_ATTEMPTS) {
      clearInterval(timer);
      // 兜底：一直等不到导航栏（很少见）就放行显示，避免永远隐藏
      docEl.classList.add(REVEAL_CLASS);
    }
  }, 100);

  // —— 监控：Hextom 若重建/挪动浮层，随时钉回导航栏 ——
  function startWatchers() {
    let scheduled = false;

    const observer = new MutationObserver(() => {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(() => {
        scheduled = false;
        // 浮层存在但已经不在导航栏里 → 移回去
        const float = getFloat();
        const host = getHost();
        if (float && host && float.parentElement !== host) {
          host.appendChild(float);
        }
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }
})();
